const timeIntervalInMilliseconds = 30 * 60 * 1000 // 30m

function canFetchNewData(state, timeIntervalToFetch) {
  if (!state?.data) return true
  if (!state?.lastSyncDate) return true
  if (Date.now() - state.lastSyncDate >= timeIntervalToFetch) return true
  return false
}

export const state = () => ({
  categories: null,
  loading: false,
  lastSyncDate: null,
})

export const mutations = {
  UPDATE_ROOT: (state, payload) => Object.assign(state, payload),
}

export const actions = {
  async fetchClientOptions(
    { state, commit },
    { forceUpdate } = { forceUpdate: false }
  ) {
    if (!canFetchNewData(state, timeIntervalInMilliseconds) && !forceUpdate)
      return

    commit('UPDATE_ROOT', { loading: true })

    const savedState = (await this.$localforage.getItem('portfolio'))
      ?.clientOptions
    if (
      (!forceUpdate &&
        savedState &&
        Date.now() - savedState.lastSyncDate < timeIntervalInMilliseconds) ||
      !window.navigator.onLine
    ) {
      commit('UPDATE_ROOT', {
        ...savedState,
        loading: false,
      })
      return
    }

    try {
      const categories = await this.$services.portfolio.fetchClientCategories()
      commit('UPDATE_ROOT', {
        categories,
        lastSyncDate: Date.now(),
      })
    } catch (error) {
      commit('UPDATE_ROOT', { lastSyncDate: null })
      window.$nuxt.$notify.error({
        message: 'Erro ao buscar categorias de clientes',
      })
    } finally {
      commit('UPDATE_ROOT', { loading: false })
    }
  },
}
